<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { specialExtras } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="specialExtras.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading colspan="2" as="th">
            {{ specialExtras.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <SectionsDetailsPdfElementsList
            :elements="details.specialExtras.extras"
            :in-two-cols-from="0"
          />
        </tbody>
      </table>
    </td>
  </tr>
</template>
